import { Box } from '@material-ui/core'
import { Card } from './components'
import { ProgressIndicator } from './ProgressIndicator'
import { useLayout } from '../../widgets/Layout'
import { getBlocks } from './OrderProgressCard.utils'

interface OrderProgressCardProps {
  order: APIResponse.DME.Order
}

const OrderProgressCard = ({ order }: OrderProgressCardProps) => {
  const uiSettings = useLayout()

  return (
    <Card>
      <Box mb={2}>
        <ProgressIndicator order={order} />
      </Box>
      {getBlocks(order, uiSettings).map(
        ({ key, component: BlockComponent, props }) => (
          <Box data-testid={key} key={key} mt={3}>
            <BlockComponent {...props} />
          </Box>
        )
      )}
    </Card>
  )
}

export default OrderProgressCard
